import * as React from 'react'
import classNames from 'classnames'

import { Game, MatchStatus } from 'protos'
import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

interface Props {
  className?: string
  values: Game.IClassicProgress['progressPart']
  max: number
}

const styles = (theme: Theme) => createStyles({
  root: {
    height: 5,
    fontSize: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.grey[50],
  },
  progress: {
    height: '100%',
    display: 'inline-block',
    transition: 'width 0.3s ease-in-out',
  },
  live: {
    background: 'linear-gradient(to bottom, #07F7A9, #00E89C)',
  },
  finished: {
    background: 'linear-gradient(to bottom, #37455f, #27354f)',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardProgressBar: React.SFC<InjectedProps> = ({
  className,
  classes,
  values,
  max,
}) => {
  return (
    <div className={classNames(className, classes.root)}>
      {(values || []).map(value => {
        const isLive = value.status === MatchStatus.MS_LIVE
        const isFinished = value.status === MatchStatus.MS_FINISHED || value.status === MatchStatus.MS_CANCELLED

        const progress = Math.max(0, Math.min(100, Math.round(100 * Number(value.progress) / max)))

        return <div
          key={`progress-${value.status!}`}
          style={{ width: `${progress}%` }}
          className={classNames(classes.progress, {
            [classes.live]: isLive,
            [classes.finished]: isFinished,
          })}
        />
      })}
    </div>
  )
}

export default withStyles(styles)(GameCardProgressBar)
